import {Injectable, Output, EventEmitter, Inject} from '@angular/core';
import {PatientsManagerService} from "./patients-manager.service";
import {Router} from "@angular/router";

@Injectable()
export class SigninService {

  login = null;
  pass = null;
  date = null;
  session = false;
  interval = null;

  @Output() clearSessionEvent = new EventEmitter();
  @Output() createSessionEvent = new EventEmitter();

  constructor(
    @Inject('patients') private _patients: PatientsManagerService,
    private router: Router
  ) {}

  createSession(login, pass, type){
    this.date = new Date();
    this.login = login;
    this.pass = pass;
    PatientsManagerService.transportType = type;
    this.session = true;
    this.interval = setInterval(
      () => this.closeSession()
      , 30 * 60 * 1000); // 30 min
    this.createSessionEvent.emit();
  }

  closeSession(){
    clearInterval(this.interval);
    this.session = false;
    this.date = null;
    this.login = null;
    this.pass = null;
    PatientsManagerService.transportType = null;

    this._patients.clear();

    this.clearSessionEvent.emit({session: 'cleared'});

    this.router.navigateByUrl('login');
  }

}



// WEBPACK FOOTER //
// ./src/app/signin.service.ts